module.exports = __webpack_public_path__ + "static/media/aids-avatar.e1ea3a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aids-avatar.jpg
// module id = 801
// module chunks = 2